/**
 * Remote lock for Windows PCs. "Lock screen now" answers with a result whatever happens, so its button
 * never leaves the status line busy; holding and releasing are admin-only and answer with the device's
 * lock as the server now holds it.
 */
import type { DeviceDto, DeviceLockDto, LockDeviceRequest, LockSessionsResult } from '../contracts.gen.js';
import { ApiError } from './auth.js';
import { request } from './http.js';

export async function lockScreen(deviceId: number, message: string | null): Promise<LockSessionsResult> {
  const body: LockDeviceRequest = { message };
  try {
    return await request<LockSessionsResult>(`/api/devices/${deviceId}/lock/screen`, { method: 'POST', body });
  } catch (error) {
    const text = error instanceof ApiError
      ? error.message || 'The lock could not be sent.'
      : `The CRM could not be reached. (${error instanceof Error ? error.message : String(error)})`;
    return { success: false, error: text, sessionsLocked: 0 };
  }
}

export function holdLock(deviceId: number, message: string | null): Promise<DeviceLockDto> {
  const body: LockDeviceRequest = { message };
  return request<DeviceLockDto>(`/api/devices/${deviceId}/lock/hold`, { method: 'POST', body });
}

export function releaseLock(deviceId: number): Promise<DeviceDto> {
  return request<DeviceDto>(`/api/devices/${deviceId}/lock/release`, { method: 'POST', body: {} });
}
